<template>
  <v-card
    :class="`${$vuetify.theme.dark ? '' : 'bg-light'} text-center`"
    :outlined="$vuetify.theme.dark"
    elevation="0"
  >
    <v-card-title class="border-bottom border-white text-center d-block font-weight-bold">
      {{ title }}
    </v-card-title>

    <v-card-text
      v-if="subject"
      class="p-0 font-weight-bold"
    >
      <v-container fluid>
        <v-row>
          <v-col>
            <p class="my-2">
              {{ subject.name }}:
              <span :class="`text-${type} p-0`">
                {{ subject.platform_diff }}% {{ subject.platform_diff > 0 ? "maior" : "menor" }} que a média geral
              </span>
            </p>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            Desempenho:
          </v-col>
          <v-col>
            <progress-bar
              :completed="Number(subject.avg)"
              :bars="10"
              :type="type"
              :suffix="`${Math.trunc(subject.avg)}%`"
            />
          </v-col>
        </v-row>
        <v-row class="border-top border-white">
          <v-col class="border-right border-white px-2 py-3">
            Média da escola: {{ subject.school_avg }}%
          </v-col>
          <v-col class=" px-2 py-3">
            Média geral: {{ subject.platform_avg }}%
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <p v-show="!subject">
      Ainda não há dados disponíveis
    </p>
  </v-card>
</template>
<script>
import ProgressBar from '@/common/components/ProgressBar'


export default {
  components: {ProgressBar},
  props:{
    title: {
      type:String,
      required:true,
    },
    type: {
      type: String,
      default: 'success',
    },
    subject:{
      type: Object,
      required: false,
      default: null,
    }
  },
}
</script>
